





import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { NewPageItem } from "../../../../domain/document/items";
import { PropertyEditableMixin, NewObjectLocatableMixin } from "./mixins";
import { Point, Vector, Size } from "../../../../domain/drawing";

@Component({
  components: {
  },
})
export default class NewNewPagePropertyEditor extends Mixins(PropertyEditableMixin, NewObjectLocatableMixin) {
  async created(): Promise<void> {
    await this.loadNewPageSource();
    this.process = () => this.locateVertically();
  }

  @Prop()
  sectionSize: Size;

  private async loadNewPageSource(): Promise<void> {
    this.editingSource = await this.createSource<NewPageItem>(s => s.vector = new Vector(new Point(0, 0), new Point(this.sectionSize ? this.sectionSize.width : 0, 0)));
  }

  @Watch("sectionSize")
  onSectionSizeChanged(): void {
    this.loadNewPageSource();
  }
}
